import React from "react";
import { Document, Page, StyleSheet, Text, View } from "@react-pdf/renderer";

const JOURS = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi"];
const MOMENTS = ["Matin", "Apres-midi"];

const styles = StyleSheet.create({
  page: {
    paddingTop: 28,
    paddingBottom: 32,
    paddingHorizontal: 24,
    backgroundColor: "#ffffff",
  },
  headerCard: {
    padding: 16,
    borderRadius: 14,
    backgroundColor: "#f6ebe4",
    marginBottom: 16,
  },
  title: {
    fontSize: 18,
    fontWeight: 700,
    color: "#3d3128",
  },
  subtitle: {
    marginTop: 4,
    fontSize: 10,
    color: "#6c584c",
  },
  table: {
    flexDirection: "column",
    marginTop: 8,
  },
  tableHeader: {
    flexDirection: "row",
    backgroundColor: "#3d3128",
    borderRadius: 6,
    marginBottom: 4,
  },
  tableHeaderCell: {
    flex: 1,
    padding: 6,
    color: "#ffffff",
    fontSize: 9,
    fontWeight: 700,
    textAlign: "center",
  },
  tableHeaderCellMoment: {
    width: 56,
    padding: 6,
    color: "#ffffff",
    fontSize: 9,
    fontWeight: 700,
  },
  tableRow: {
    flexDirection: "row",
    marginBottom: 4,
  },
  momentCell: {
    width: 56,
    padding: 6,
    fontSize: 9,
    fontWeight: 700,
    color: "#6c584c",
    backgroundColor: "#f6ebe4",
    borderRadius: 4,
    justifyContent: "center",
  },
  cell: {
    flex: 1,
    padding: 4,
    marginHorizontal: 2,
    minHeight: 40,
    backgroundColor: "#fffaf7",
    borderRadius: 4,
    border: "1 solid #ead5c9",
  },
  cellEmpty: {
    flex: 1,
    padding: 4,
    marginHorizontal: 2,
    minHeight: 40,
    backgroundColor: "#f9f9f9",
    borderRadius: 4,
    border: "1 solid #e8e8e8",
    justifyContent: "center",
    alignItems: "center",
  },
  activityName: {
    fontSize: 8,
    fontWeight: 700,
    color: "#3d3128",
  },
  activityProf: {
    marginTop: 2,
    fontSize: 7,
    color: "#5f4b40",
  },
  activityBadge: {
    marginTop: 2,
    fontSize: 7,
    color: "#0c7b56",
  },
  emptyText: {
    fontSize: 7,
    color: "#b0b0b0",
    textAlign: "center",
  },
});

function PlanningGlobalPdf(props) {
  const parcours = props.parcours || {};
  const parcoursLabelMap = props.parcoursLabelMap || {};
  const semaineLabel = props.semaineLabel || "";

  const parcoursIds = Object.keys(parcours);

  const getActiviteForMoment = (indexMoment) => {
    const found = [];
    parcoursIds.forEach((parcoursId) => {
      (parcours[parcoursId] || [])
        .filter((item) => item.indexMoment === indexMoment && item.activite)
        .forEach((item) => {
          const existing = found.find((f) => f.activiteId === item.activiteId);
          if (existing) {
            if (!existing.parcoursIds.includes(String(parcoursId))) {
              existing.parcoursIds.push(String(parcoursId));
            }
          } else {
            found.push({ ...item, parcoursIds: [String(parcoursId)] });
          }
        });
    });
    return found;
  };

  const getParcoursLabel = (parcoursId) => {
    return parcoursLabelMap[String(parcoursId)] || `Parcours ${parcoursId}`;
  };

  const getBadgeText = (item) => {
    if (item.parcoursIds.length === parcoursIds.length && parcoursIds.length > 1) {
      return "Tous les parcours";
    }
    return item.parcoursIds.map(getParcoursLabel).join(", ");
  };

  return (
    <Document>
      <Page size="A4" orientation="landscape" style={styles.page}>
        <View style={styles.headerCard}>
          <Text style={styles.title}>Planning global des activites</Text>
          <Text style={styles.subtitle}>Semaine : {semaineLabel}</Text>
        </View>

        <View style={styles.table}>
          <View style={styles.tableHeader}>
            <View style={styles.tableHeaderCellMoment}>
              <Text style={{ fontSize: 9, color: "#ffffff" }}>Moment</Text>
            </View>
            {JOURS.map((jour) => (
              <Text key={jour} style={styles.tableHeaderCell}>
                {jour}
              </Text>
            ))}
          </View>

          {MOMENTS.map((moment, momentIndex) => {
            return (
              <View key={moment} style={styles.tableRow}>
                <View style={styles.momentCell}>
                  <Text>{moment}</Text>
                </View>

                {JOURS.map((jour, jourIndex) => {
                  const indexMoment = jourIndex * 2 + momentIndex;
                  const activites = getActiviteForMoment(indexMoment);

                  if (activites.length === 0) {
                    return (
                      <View key={jour} style={styles.cellEmpty}>
                        <Text style={styles.emptyText}>-</Text>
                      </View>
                    );
                  }

                  return (
                    <View key={jour} style={styles.cell}>
                      {activites.map((item) => (
                        <View key={item.activiteId} style={{ marginBottom: 4 }}>
                          <Text style={styles.activityBadge}>
                            {getBadgeText(item)}
                          </Text>
                          <Text style={styles.activityName}>
                            {item.activite.nom}
                          </Text>
                          {item.activite.professeur && (
                            <Text style={styles.activityProf}>
                              {item.activite.professeur.prenom}{" "}
                              {item.activite.professeur.nom}
                            </Text>
                          )}
                        </View>
                      ))}
                    </View>
                  );
                })}
              </View>
            );
          })}
        </View>
      </Page>
    </Document>
  );
}

export default PlanningGlobalPdf;
